var React = require('react');

function I (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.898193 0.329937C3.73619 0.329937 3.93417 2.67294 3.93417 9.17394V23.8259C3.93417 30.3269 3.73619 32.6699 0.898193 32.6699V32.9999H9.8082V32.6699C6.9702 32.6699 6.77219 30.3269 6.77219 23.8259V9.17394C6.77219 2.67294 6.9702 0.329937 9.8082 0.329937V-6.10352e-05H0.898193V0.329937Z","fill":"currentColor"}));
}

I.defaultProps = {"width":"10","height":"33","viewBox":"0 0 10 33","fill":"none"};

module.exports = I;

I.default = I;
